import { useState, useEffect, useCallback } from 'react';
import { billingService, BalanceResponse } from '@/services/billingService';

export const useBalance = () => {
  const [balance, setBalance] = useState<number>(0);
  const [balanceData, setBalanceData] = useState<BalanceResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLowBalance, setIsLowBalance] = useState(false);
  const [isZeroBalance, setIsZeroBalance] = useState(false);

  const fetchBalance = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await billingService.getBalance();
      setBalanceData(data);
      setBalance(data.balance_usd);
      setIsLowBalance(data.is_low_balance);
      setIsZeroBalance(data.is_zero_balance);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch balance';
      setError(errorMessage);
      console.error('Error fetching balance:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Fetch balance on mount
  useEffect(() => {
    // Only fetch balance if user is authenticated
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      fetchBalance();
    }
  }, [fetchBalance]);

  return {
    balance,
    balanceData,
    isLoading,
    error,
    isLowBalance,
    isZeroBalance,
    refreshBalance: fetchBalance,
  };
};
